define('tracks/starred',["require", "exports", "../util/http", "../util/pubsub"], function (require, exports, http_1, pubsub_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.bind = exports.init = exports.updates = exports.tracks = void 0;
    exports.updates = new pubsub_1.PubSub();
    var savedUserId;
    function init(userId) {
        if (userId) {
            exports.tracks = (0, http_1.getJson)("/users/" + userId + "/starred.json");
            savedUserId = userId;
        }
    }
    exports.init = init;
    /**
     * Bind a track to a toggle button
     */
    function bind(track, button) {
        // Update initial state
        var update = function () {
            if (track.starred) {
                button.src = "/assets/images/icons/star-filled.svg";
            }
            else {
                button.src = "/assets/images/icons/star.svg";
            }
        };
        update();
        // Bind to click
        button.addEventListener("click", function (e) {
            track.starred = !track.starred;
            button.src = "/assets/images/icons/star-pending.svg";
            (0, http_1.postJson)("/tracks/" + track.track_id + "/starred", track.starred).then(function () {
                init(savedUserId);
                exports.updates.post();
                update();
            }).catch(function (error) {
                console.error("Failed to toggle starred track", error);
            });
            e.stopPropagation();
        });
    }
    exports.bind = bind;
});
//# sourceMappingURL=/assets/javascripts/tracks/starred.js.map;
